
    <div *ngIf="loading" class="index-loading-wrapper">
      <div class="index-loader"></div>
    </div>
    <router-outlet> </router-outlet>
  